import Upload from 'adeliom-upload-js';

const settings = {
    selector: '.gform_fileupload_multifile',
    multiple: true,
    maxNbFiles: 4,
    dropZone: false,
    displayMaxFileSize: false,
    displayRestSize: false,
    displayRestFiles: false,
    language: 'fr',
    languages: {
        fr: {
            textBtnUpload: '<div class="flex p-8 w-full border border-gray-400 flex-col gap-4 items-center"><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 1.5C9 0.947716 8.55228 0.5 8 0.5C7.44772 0.5 7 0.947715 7 1.5V8.65777L3.75724 5.41501L2.34303 6.82922L7.99988 12.4861L13.6567 6.82922L12.2425 5.41501L9 8.65753V1.5Z" fill="#B4B4B4" /> <path d="M16 10.5H14V14.5H2V10.5H0V14.5C0 15.6046 0.895431 16.5 2 16.5H14C15.1046 16.5 16 15.6046 16 14.5V10.5Z" fill="#B4B4B4" /></svg> <p class="text-gray-400">Glissez déposez votre pièce-jointe ici</p> <span class="flex items-center gap-3 font-semibold hover"> <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M0.25 2.25C0.25 1.00736 1.25736 0 2.5 0H8.5C11.3995 0 13.75 2.35051 13.75 5.25V12.75C13.75 13.9926 12.7426 15 11.5 15H2.5C1.25736 15 0.25 13.9926 0.25 12.75V2.25ZM7.75 1.5H2.5C2.08579 1.5 1.75 1.83579 1.75 2.25V12.75C1.75 13.1642 2.08579 13.5 2.5 13.5H11.5C11.9142 13.5 12.25 13.1642 12.25 12.75V5.25H7.75V1.5ZM11.938 3.75C11.456 2.64679 10.4585 1.82033 9.25 1.57501V3.75H11.938Z" fill="#FF9C00" /> </svg> Ajouter un fichier </span></div>',
        }
    },
    customContentOnly: false,
    };

const uploadField = new Upload(settings);
uploadField.init();

